import { render } from "./ReferencesPages.vue?vue&type=template&id=483f9aba"
import script from "./ReferencesPages.vue?vue&type=script&lang=js"
export * from "./ReferencesPages.vue?vue&type=script&lang=js"

import "./ReferencesPages.vue?vue&type=style&index=0&id=483f9aba&lang=css"
script.render = render

export default script